export const generateSubjectTitle = (
  printPublicationTrigramme: string,
  printIssueTitle: string,
  printHeadingTitle: string,
) => {
  const splitPrintHeadingTitle = printHeadingTitle.split('-');
  const rubrique = splitPrintHeadingTitle[1] || splitPrintHeadingTitle[0];
  return `${printPublicationTrigramme} ${printIssueTitle} ${rubrique.trim()}`;
};
